import React, { PropsWithChildren, useState } from "react";
import { twJoin } from "tailwind-merge";

import SupInfoCircle from "../../../icons/InfoCircle";
import SupX from "../../../icons/X";

export interface StatusProps {
  status?: boolean;
  label?: string;
}

/**
 * **Deprecated:** Use `Notification/AlertBar` instead
 */
export function SupStatus({ status = false, label = "Protocol status", children }: PropsWithChildren<StatusProps>) {
  const [hidden, toggleStatus] = useState<boolean>(false);

  if (!status || !children) {
    return null;
  }

  return (
    <div className={twJoin("m-4 bg-info-300 font-mono p-4 text-info-800", hidden && "hidden")}>
      <div className="flex items-center justify-between w-full">
        <SupInfoCircle className="stroke-0 w-[20px] h-[20px]" />
        <div className="flex flex-col leading-[16px] justify-center min-[744px]:flex-row min-[744px]:gap-2 items-center">
          <p className="text-base mb-2 font-bold text-center uppercase min-[744px]:mb-0">{label}</p>
          <p className="text-xs uppercase">{children}</p>
        </div>
        <SupX
          onClick={() => {
            toggleStatus(true);
          }}
          className="cursor-pointer stroke-0 hover:opacity-70"
        />
      </div>
    </div>
  );
}
